import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import AdminDashboard from '../admin/pages/AdminDashboard';
import FrontDeskDashboard from '../front-desk/pages/FrontDeskDashboard';
import FloatingAboutButton from '@medical/shared/components/FloatingAboutButton';

const AdminMainContent = styled.main`
  min-height: 100vh;
`;

const FrontDeskMainContent = styled.main`
  min-height: 100vh;
`;

export const AdminPortalApp = () => (
  <AdminMainContent>
    <Routes>
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
    </Routes>
  </AdminMainContent>
);

export const FrontDeskPortalApp = () => (
  <>
    <FrontDeskMainContent>
      <Routes>
        <Route path="/front-desk" element={<FrontDeskDashboard />} />
        <Route path="/front-desk/dashboard" element={<FrontDeskDashboard />} />
        <Route path="/front-desk/*" element={<Navigate to="/front-desk" replace />} />
      </Routes>
    </FrontDeskMainContent>
    <FloatingAboutButton />
  </>
);
